import "./EditInstructionRows.html";
import "./EditInstructionRows.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EditInstructionRowsComponentController from "./EditInstructionRowsComponentController";

export default class EditInstructionRowsComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            heading: "<",
            instruction: "=",
        };
        this.controller = EditInstructionRowsComponentController;
        this.templateUrl = "/App/Components/Forms/EditInstructionRows/EditInstructionRows.html";
    }
}

module("mmManagePortal").component("mmEditInstructionRows", new EditInstructionRowsComponent());
